import { cn } from "@tellescope/design-system";
import type { ContactDetailsBlockType, BlockBaseConfig } from "../../types";
import { Check } from "lucide-react";
import { getBlockConfig } from "../../constants";

export interface BlockSelectionItemProps {
  blockType: ContactDetailsBlockType;
  isSelected: boolean;
  existingCount?: number;
  onClick: () => void;
  className?: string;
}

export const BlockSelectionItem = ({
  blockType,
  isSelected,
  existingCount = 0,
  onClick,
  className,
}: BlockSelectionItemProps) => {
  const config: BlockBaseConfig = getBlockConfig(blockType);
  const isOnView = existingCount > 0;

  return (
    <button
      onClick={onClick}
      className={cn(
        "relative overflow-hidden rounded-md border border-muted flex flex-col hover:shadow-md transition-all",
        isSelected && "border-primary",
        className
      )}
    >
      <img
        src={config.previewUrl}
        alt={config.getName()}
        className="aspect-video w-full object-cover border-b border-muted"
      />
      <div className="p-2 space-y-2 bg-muted">
        <p className="text-sm font-semibold text-left">{config.getName()}</p>
        <p className="text-xs font-light text-muted-foreground text-left">{config.getDescription()}</p>
      </div>
      {(isSelected || isOnView) && (
        <div
          className={cn(
            "flex items-center justify-center gap-0.5 p-1 h-6 min-w-6 rounded-full absolute top-2 right-2",
            isSelected ? "bg-primary text-primary-foreground" : "bg-secondary text-secondary-foreground"
          )}
        >
          <Check className="size-4 shrink-0" />
          {existingCount > 1 && <span className="text-xs font-semibold leading-none pr-0.5">{existingCount}</span>}
        </div>
      )}
    </button>
  );
};
